<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div
  #elementDiv
  class="cell {{ cell().status }}"
  [ngClass]="{ selected: cell().selected, enable: enable() }"
  (dragover)="allowDrop($event)"
  (drop)="drop()"
>
  <span class="date">{{ cell().label }}</span>
  @if (isCurrentDay()) {
    <div class="corner top-left"></div>
  }
</div>
